import { Navigation } from '@angular/router';
import { SiteInstallRequirements } from '@ffd/api-client';

/**
 * The showcase guard already fetches the site install requirements before it redirects an unsupported PMS into the setup
 * flow. It hands the response over in the navigation state under this key, so the setup flow does not request it again.
 */
export const SITE_INSTALL_REQUIREMENTS_STATE_KEY = 'siteInstallRequirements';

export const getSiteInstallRequirementsFromNavigation = (navigation: Navigation | null): SiteInstallRequirements | null => {
  // A back/forward navigation and the first navigation after a page reload both restore the state saved in the history
  // entry, which can be outdated by then. Only the guard's redirect, which always follows an earlier navigation, is trusted.
  if (navigation?.trigger !== 'imperative' || !navigation.previousNavigation) {
    return null;
  }

  return (navigation.extras.state?.[SITE_INSTALL_REQUIREMENTS_STATE_KEY] as SiteInstallRequirements | undefined) ?? null;
};
